import { supabase } from '../../lib/supabase'

export type OpenShiftDecisionKind = 'approve' | 'deny'

export type DecideOpenShiftClaimParams = {
  claimId: string
  decision: OpenShiftDecisionKind
  comment?: string
}

export type OpenShiftDecisionResult = { ok: true } | { ok: false; message: string }

// The only path to approve or deny a claim: v1-decide-open-shift-claim records
// the decision and, for an approval, amends the published schedule in one
// transaction. A refusal carries its reason (the slot was filled, the period
// is no longer published), which the supervisor reads rather than a generic
// failure.
export async function decideOpenShiftClaim(params: DecideOpenShiftClaimParams): Promise<OpenShiftDecisionResult> {
  const { error } = await supabase.functions.invoke('v1-decide-open-shift-claim', { body: params })
  if (!error) return { ok: true }

  let message = error.message
  const context = (error as { context?: { json?: () => Promise<{ error?: string }> } }).context
  if (context?.json) {
    try {
      const body = await context.json()
      if (body.error) message = body.error
    } catch {
      // The body was not JSON; the error's own message stands.
    }
  }
  return { ok: false, message: message || 'The decision could not be recorded.' }
}
